import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { CiRedo } from "react-icons/ci";
import { FiFileText } from "react-icons/fi";
import { RxLightningBolt } from "react-icons/rx";
import { IoIosContact } from "react-icons/io";
import { SlLocationPin } from "react-icons/sl";
import { SlPhone } from "react-icons/sl";
import { MdOutlineEmail } from "react-icons/md";
import UpdateSenderAdd from "./UpdateSenderAdd";
import UpdateReciverAdd from "./UpdateReciverAdd";
import UpdateOrderDetails from "./UpdateOrderDetails";
import { LuArrowDownUp } from "react-icons/lu";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import UpdateReceiverAdd from "./UpdateReciverAdd";
import { ArrowLeft } from "lucide-react";
import { ArrowDown, MapPin, IndianRupee, Package } from "lucide-react";
// import { toast } from "react-toastify";
import Cookies from "js-cookie";
import {Notification} from "../../Notification"

import EmployeeAuthModal from "../../employeeAuth/EmployeeAuthModal";
const OrderDetails = ({ isSidebarAdmin }) => {
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [employeeAccess, setEmployeeAccess] = useState({
    isAdmin: false,
    canUpdate: false,
  });
  const [showEmployeeAuthModal, setShowEmployeeAuthModal] = useState(false);
  const [order, setOrder] = useState(null);
  const [tracking, setTracking] = useState([]);
  const [error, setError] = useState("");
  const { id } = useParams();
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const navigate = useNavigate();


  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const token = Cookies.get("session");

        if (isSidebarAdmin) {
          // Sidebar admin: full access, no modal
          setEmployeeAccess({ isAdmin: true, canUpdate: true });
          setShowEmployeeAuthModal(false);
        } else {
          // Check if this is an employee session
          const userInfo = JSON.parse(atob(token.split(".")[1]));
          if (userInfo.employee && userInfo.employee.isEmployee === true) {
            // Employee: check access rights
            const employeeResponse = await axios.get(
              `${REACT_APP_BACKEND_URL}/staffRole/verify`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            const employee = employeeResponse.data.employee;
            const canUpdate =
              !!employee?.accessRights?.orders?.["All Orders"]?.update;
            setEmployeeAccess({ canUpdate });
            if (!canUpdate) setShowEmployeeAuthModal(true);
          } else {
            // Normal user: do not show employee modal, allow access
            setEmployeeAccess({ isAdmin: false, canUpdate: true });
            setShowEmployeeAuthModal(false);
          }
        }

        // Fetch order details as usual
        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/getOrderById/${id}`,
          { headers: { authorization: `Bearer ${token}` } }
        );

        setOrder(response.data);

        // Filter out objects that contain only _id
        const filteredTracking = response.data.tracking
          ? response.data.tracking.filter(
            (item) => Object.keys(item).length > 1
          )
          : [];
        setTracking(filteredTracking);
      } catch (error) {
        console.error("Error fetching order:", error);
        setError(error.response?.data?.error || "Failed to fetch order.");
      }
    };

    fetchOrder();
  }, [id, isSidebarAdmin, REACT_APP_BACKEND_URL]);

  const handleUpdateSenderDetails = async (updatedData) => {
    try {
      const token = Cookies.get("session");
      console.log("Sending request with orderId:", id); // Debugging

      await axios.put(
        `${REACT_APP_BACKEND_URL}/order/updateOrder/${id}`, // Keep as a string
        { pickupAddress: updatedData },

        { headers: { authorization: `Bearer ${token}` } }
      );

      console.log("Updated Data:", updatedData);

      setOrder((prevOrder) => ({
        ...prevOrder,
        pickupAddress: updatedData,
      }));
      Notification("Sender details updated successfully","success");
      console.log("Updated order state:", order);
    } catch (error) {
      Notification("Failed to update sender details","error");
      console.error("Error updating sender details:", error);
    }
  };

  const handleUpdateRecieverDetails = async (updatedRecieverAddress) => {
    try {
      const token = Cookies.get("session");
      console.log("Sending request with orderId:", id); // Debugging

      await axios.put(
        `${REACT_APP_BACKEND_URL}/order/updateOrder/${id}`, // Keep as a string

        { receiverAddress: updatedRecieverAddress },
        { headers: { authorization: `Bearer ${token}` } }
      );

      setOrder((prevOrder) => ({
        ...prevOrder,

        receiverAddress: updatedRecieverAddress,
      }));
      Notification("Receiver details updated successfully","success");
      console.log("Updated order state:", order);
    } catch (error) {
      Notification("Failed to update receiver details","error");
      console.error("Error updating sender details:", error);
    }
  };

  const handleUpdateOrderDetails = async (updatedOrderData) => {
    try {
      const token = Cookies.get("session");
      if (!order.paymentDetails) {
        order.paymentDetails = {}; // Initialize to prevent undefined errors
      }

      const formattedData = {
        paymentDetails: {
          method: updatedOrderData.paymentMethod,
          amount: updatedOrderData.codAmount, // Ensure correct mapping
        },
        packageDetails: {
          applicableWeight: updatedOrderData.weight,
          volumetricWeight: {
            length: updatedOrderData.length,
            width: updatedOrderData.breadth,
            height: updatedOrderData.height,
          },
        },
      };

      await axios.put(
        `${REACT_APP_BACKEND_URL}/order/updateOrder/${id}`,
        formattedData, // Send the correctly structured data
        { headers: { authorization: `Bearer ${token}` } }
      );

      console.log("Order updated successfully");
    } catch (error) {
      console.error("Error updating order details:", error);
    }
  };

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  if (!order) {
    return <div>Loading...</div>;
  }

  return (
    <div className="md:p-2 md:w-full w-3/3 p-1 text-gray-500">
      <div className="flex items-center mb-4">
        <button
          onClick={() => navigate(-1)}
          className="mr-3 p-2 rounded-full hover:bg-purple-200 transition"
          title="Go Back"
        >
          <ArrowLeft className="w-4 h-4 text-gray-500" />
        </button>

        <h1 className="sm:text-[18px] font-[600] text-[18px] text-gray-700">
          Order# <span className="text-[#632C9D]">{order.orderId}</span>
        </h1>

        <span className="px-2 font-[600] py-1 sm:ml-2 rounded text-[8px] sm:text-[10px] bg-purple-100 text-purple-700">
          {order.status}
        </span>
      </div>

      {/* <nav className="text-sm text-gray-600 mb-4">
        Home &gt; Orders &gt; <span className="text-gray-800">View Order</span>
      </nav> */}
      <div className="block md:hidden bg-white rounded-lg shadow-sm p-4 w-full max-w-md mx-auto mt-2">
        <div className="flex justify-between text-center text-[12px]">
          {/* From - To */}
          <div className="flex flex-col items-center w-1/3 pr-2">
            <div className="bg-[#f4f4f5] p-2 rounded-full mb-2">
              <MapPin className="w-5 h-5 text-[#6b7280]" />
            </div>
            <div className="text-xs font-medium text-black">{order?.pickupAddress?.state || "N/N"}</div>
            <div className="text-[10px] text-gray-500">{order?.pickupAddress?.pinCode || "N/N"}</div>
            <ArrowDown className="w-3 h-3 text-gray-400 my-1" />
            <div className="text-xs font-medium text-black">{order?.receiverAddress?.state || "N/N"}</div>
            <div className="text-[10px] text-gray-500">{order?.receiverAddress?.pinCode || "N/N"}</div>
          </div>

          {/* Payment */}
          <div className="flex flex-col items-center w-1/3 px-2 border-x border-gray-200">
            <div className="bg-[#f4f4f5] p-2 rounded-full mb-2">
              <IndianRupee className="w-5 h-5 text-[#6b7280]" />
            </div>
            <div className="text-xs font-medium text-black">{order?.paymentDetails?.method || "N/N"}</div>
            <div className="text-[10px] text-gray-500 mt-1">Order Value</div>
            <div className="text-base font-semibold text-black">₹{order?.paymentDetails?.amount || "N/N"}</div>
          </div>

          {/* Weight */}
          <div className="flex flex-col items-center w-1/3 pl-2">
            <div className="bg-[#f4f4f5] p-2 rounded-full mb-2">
              <Package className="w-5 h-5 text-[#6b7280]" />
            </div>
            <div className="text-xs font-medium text-black">{order?.packageDetails?.applicableWeight}KG</div>
            <div className="text-[10px] text-gray-500 mt-1">(Dead Weight)</div>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-2 mt-2">
        {/* Sender Details */}
        <div className="bg-white md:p-4 p-4 rounded-lg shadow-sm col-span-1">
          <div className="flex justify-between">
            <h2 className="text-[14px] font-[600]">
              Sender Details
            </h2>
            {/* <button onClick={() => setIsModalOpen1(true)} className="mb-8">
              <FaEdit className="text-gray-400 hover:text-black" />
            </button> */}
            {order.status === "new" &&
              (isSidebarAdmin ||
                employeeAccess.isAdmin ||
                employeeAccess.canUpdate ? (
                <button onClick={() => setIsModalOpen1(true)} className="mb-4 w-8 flex justify-center items-center h-8 bg-gray-500 rounded-full">
                  <FaEdit className="text-white hover:text-black" />
                </button>
              ) : (
                <button
                  onClick={() => setShowEmployeeAuthModal(true)}
                  className="mb-4 w-8 flex justify-center items-center h-8 bg-gray-500 rounded-full"
                  title="You do not have permission to update"
                >
                  <FaEdit className="text-white cursor-not-allowed" />
                </button>
              ))}

            {!isSidebarAdmin && showEmployeeAuthModal && (
              <EmployeeAuthModal
                employeeModalShow={showEmployeeAuthModal}
                employeeModalClose={() => {
                  setShowEmployeeAuthModal(false);
                  // window.history.back();
                }}
              />
            )}
          </div>

          <div className="flex border-b">
            <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
              <IoIosContact />
            </p>
            <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
              <strong className="mb-1 text-gray-500">Name</strong>
              <span>{order.pickupAddress?.contactName}</span>
            </p>
          </div>

          <div className="flex border-b">
            <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
              <SlLocationPin />
            </p>
            <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
              <strong className="mb-1 text-gray-500">Address</strong>
              <span>{order.pickupAddress?.address}</span>
            </p>
          </div>

          <div className="flex border-b">
            <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
              <SlPhone />
            </p>
            <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
              <strong className="mb-1 text-gray-500">Phone</strong>
              <span>{order.pickupAddress?.phoneNumber}</span>
            </p>
          </div>

          <div className="flex border-b">
            <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
              <MdOutlineEmail />
            </p>
            <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
              <strong className="mb-1 text-gray-500">Email</strong>
              <span>{order.pickupAddress?.email}</span>
            </p>
          </div>
          <div className="flex justify-between items-center">
            <div className="flex">
              <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
                <SlLocationPin />
              </p>
              <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
                <strong className="mb-1 text-gray-500">City</strong>
                <span>{order.pickupAddress?.city}</span>
              </p>
            </div>
            <div className="flex">
              {/* <p className="mt-4 mr-4">
                <MdOutlineEmail className="text-gray-400" />
              </p> */}
              <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
                <strong className="mb-1 text-gray-500">State</strong>
                <span>{order.pickupAddress?.state}</span>
              </p>
            </div>
            <div className="flex">
              {/* <p className="mt-4 mr-4">
                <MdOutlineEmail className="text-gray-400" />
              </p> */}
              <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
                <strong className="mb-1 text-gray-500">Pincode</strong>
                <span>{order.pickupAddress?.pinCode}</span>
              </p>
            </div>
          </div>
        </div>

        {/* Receiver Details */}
        <div className="bg-white p-4 rounded-lg shadow-sm col-span-1">
          <div className="flex justify-between">
            <h2 className="sm:text-[14px] text-[12px] font-[600] pb-2">
              Receiver Details
            </h2>
            {order.status === "new" &&
              (isSidebarAdmin ||
                employeeAccess.isAdmin ||
                employeeAccess.canUpdate ? (
                <button onClick={() => setIsModalOpen2(true)} className="mb-4 w-8 flex justify-center items-center h-8 bg-gray-500 rounded-full">
                  <FaEdit className="text-white hover:text-black" />
                </button>
              ) : (
                <button
                  onClick={() => setShowEmployeeAuthModal(true)}
                  className="mb-4 w-8 flex justify-center items-center h-8 bg-gray-500 rounded-full"
                  title="You do not have permission to update"
                >
                  <FaEdit className="text-white hover:text-black" />
                </button>
              ))}

            {/* <button onClick={() => setIsModalOpen2(true)} className="mb-8">
              <FaEdit className="text-gray-400 hover:text-black" />
            </button> */}
          </div>

          <div className="flex border-b">
            <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
              <IoIosContact />
            </p>
            <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
              <strong className="mb-1 text-gray-500">Name</strong>
              <span>{order.receiverAddress?.contactName}</span>
            </p>
          </div>

          <div className="flex border-b">
            <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
              <SlLocationPin />
            </p>
            <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
              <strong className="mb-1 text-gray-500">Address</strong>
              <span>{order.receiverAddress?.address}</span>
            </p>
          </div>

          <div className="flex border-b">
            <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
              <SlPhone />
            </p>
            <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
              <strong className="mb-1 text-gray-500">Phone</strong>
              <span>{order.receiverAddress?.phoneNumber}</span>
            </p>
          </div>

          <div className="flex border-b">
            <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
              <MdOutlineEmail />
            </p>
            <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
              <strong className="mb-1 text-gray-500">Email</strong>
              <span>{order.receiverAddress?.email}</span>
            </p>
          </div>
          <div className="flex justify-between items-center">
            <div className="flex">
              <p className="mt-3 mr-4 flex justify-center items-center w-8 h-8 bg-[#632C9D] text-white p-1 rounded-full">
                <SlLocationPin />
              </p>
              <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
                <strong className="mb-1 text-gray-500">City</strong>
                <span>{order.receiverAddress?.city}</span>
              </p>
            </div>
            <div className="flex">
              {/* <p className="mt-4 mr-4">
                <MdOutlineEmail className="text-gray-400" />
              </p> */}
              <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
                <strong className="mb-1 text-gray-500">State</strong>
                <span>{order.receiverAddress?.state}</span>
              </p>
            </div>
            <div className="flex">
              {/* <p className="mt-4 mr-4">
                <MdOutlineEmail className="text-gray-400" />
              </p> */}
              <p className="text-[12px] pb-2 mb-2 mt-2 flex flex-col">
                <strong className="mb-1 text-gray-500">Pincode</strong>
                <span>{order.receiverAddress?.pinCode}</span>
              </p>
            </div>
          </div>
        </div>

        {/* tracking */}

        <div className="bg-white p-4 rounded-lg shadow-sm col-span-1">
          <h2 className="sm:text-[14px] text-[12px] font-[600] border-b pb-2 mb-4">
            Tracking Details
          </h2>
          <div className="mt-4 overflow-y-auto w-full max-h-80">
            <div className="space-y-3">
              {[
                ...new Map(
                  tracking
                    .filter((item) => item.Instructions && item.StatusDateTime) // Filter valid items
                    .reverse() // So we keep the latest entry
                    .map((item) => [item.StatusDateTime, item]) // Use StatusDateTime as key
                ).values(),
              ]
                .reverse() // Restore original order
                .map((item, index, filteredArray) => (
                  <div
                    key={index}
                    className="relative w-full flex gap-4 sm:gap-6 mb-6 sm:mb-8"
                  >
                    {/* Left: Date & Time */}
                    <div className="w-1/4 text-right pr-1">
                      {(() => {
                        const date = new Date(item.StatusDateTime);

                        const year = date.getUTCFullYear();
                        const month = date.toLocaleString("en-US", {
                          month: "short",
                          timeZone: "UTC",
                        }); // Apr
                        const day = String(date.getUTCDate()).padStart(2, "0");

                        let hours = date.getUTCHours();
                        const minutes = String(date.getUTCMinutes()).padStart(
                          2,
                          "0"
                        );
                        const amPm = hours >= 12 ? "PM" : "AM";
                        hours = hours % 12 || 12;
                        const hourStr = String(hours).padStart(2, "0");

                        return (
                          <>
                            <p className="text-[10px] sm:text-[12px] font-[600]">
                              {`${year} ${month} ${day}`}
                            </p>
                            <p className="text-[10px] sm:text-[12px] text-gray-500">
                              {`${hourStr}:${minutes} ${amPm}`}
                            </p>
                          </>
                        );
                      })()}
                    </div>

                    {/* Middle: Timeline (Circle + Line) */}
                    <div className="flex flex-col items-center relative">
                      <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full border-2 z-10 bg-purple-500 border-green-500"></div>
                      {index !== filteredArray.length - 1 && (
                        <div className="w-0.5 flex-1 bg-purple-500 mt-1"></div>
                      )}
                    </div>

                    {/* Right: Activity & Location */}
                    <div className="w-2/3 text-left">
                      <p className="text-[10px] sm:text-[12px] mb-1">
                        <span className="font-semibold">Activity</span>:{" "}
                        {item.Instructions}
                      </p>
                      <p className="text-[10px] sm:text-[12px]">
                        <span className="font-semibold">Location</span>:{" "}
                        {item.StatusLocation}
                      </p>
                      <hr className="mt-3 sm:mt-4" />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-2 mt-2">
        {/* Product Details */}
        <div className="bg-white w-full sm:w-2/3 p-4 rounded-lg shadow-sm">
          <h2 className="text-[12px] lg:text-[14px] font-[600] pb-2 mb-2">
            Product Details
          </h2>

          {/* Desktop View (Table) */}
          <div className="hidden sm:block">
            <table className="w-full text-left">
              <thead>
                <tr className="text-gray-500 text-[14px]">
                  <th className="py-2 px-3">Product Name</th>
                  <th className="py-2 px-3">Quantity</th>
                  <th className="py-2 px-3">Price</th>
                  <th className="py-2 px-3">SKU</th>
                </tr>
              </thead>
              <tbody>
                {order.productDetails.map((product, index) => (
                  <tr key={index} className="border-b text-[12px]">
                    <td className="py-2 px-3">{product.name}</td>
                    <td className="py-2 px-3">{product.quantity}</td>
                    <td className="py-2 px-3">₹{product.unitPrice}</td>
                    <td className="py-2 px-3">{product.sku}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile View (Stacked Layout) */}
          <div className="sm:hidden">
            {order.productDetails.map((product, index) => (
              <div key={index} className="border-b pb-4 mb-2">
                <div className="grid grid-cols-2 text-[12px] gap-y-2">
                  <span className="font-[600] text-gray-700">
                    Product Name
                  </span>
                  <span className="font-[400]">{product.name}</span>

                  <span className="font-[600] text-gray-700">Quantity</span>
                  <span className="font-[400]">{product.quantity}</span>

                  <span className="font-[600] text-gray-700">Price</span>
                  <span className="font-[400]">₹{product.unitPrice}</span>

                  <span className="font-[600] text-gray-700">SKU</span>
                  <span className="font-[400]">{product.sku}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Order Details */}
        <div className="bg-white w-full sm:w-1/3 p-4 rounded-lg shadow-sm">
          <div className="flex justify-between items-start mb-2 border-b">
            <h2 className="sm:text-[14px] text-[12px] font-[600]">Order Details</h2>

            {order.status === "new" &&
              (isSidebarAdmin ||
                employeeAccess.isAdmin ||
                employeeAccess.canUpdate ? (
                <button onClick={() => setIsModalOpen3(true)} className="mb-4 w-8 flex justify-center items-center h-8 bg-gray-500 rounded-full">
                  <FaEdit className="text-white hover:text-black" />
                </button>
              ) : (
                <button
                  onClick={() => setShowEmployeeAuthModal(true)}
                  className="mb-4 w-8 flex justify-center items-center h-8 bg-gray-500 rounded-full"
                  title="You do not have permission to update"
                >
                  <FaEdit className="text-white cursor-not-allowed" />
                </button>
              ))}

            {/* <button
              onClick={() => setIsModalOpen3(true)}
              className="text-gray-400 hover:text-black"
            >
              <FaEdit />
            </button> */}
          </div>

          {/* Desktop View (3-Column Grid) */}
          <div className="hidden sm:grid grid-cols-3 gap-y-3 text-[12px] text-gray-500">
            <span className="font-[400]">Order Number</span>
            <span className="text-wrap [400]">:</span>
            <span className="text-wrap font-[600]">{order.orderId}</span>

            <span className="font-[400]">Payment Method</span>
            <span className="text-wrap font-[400]">:</span>
            <span className="text-wrap font-[600]">
              {order.paymentDetails.method}
            </span>

            <span className="font-[400]">Dimension</span>
            <span className="text-wrap font-[400]">:</span>
            <span className="text-wrap font-[600]">
              {order.packageDetails.volumetricWeight.height} x{" "}
              {order.packageDetails.volumetricWeight.length} x{" "}
              {order.packageDetails.volumetricWeight.width}
            </span>

            <span className="font-[400]">Weight</span>
            <span className="text-wrap font-[400]">:</span>
            <span className="text-wrap font-[600]">
              {order.packageDetails.applicableWeight} Kg
            </span>

            <span className="font-[400]">Order Value</span>
            <span className="text-wrap font-[400]">:</span>
            <span className="text-start font-[600]">
              ₹{order.paymentDetails.amount}
            </span>
          </div>

          {/* Mobile View (2-Column Grid) */}
          <div className="sm:hidden grid grid-cols-2 gap-y-3 text-[12px] text-gray-700">
            <span className="font-medium">Order Number</span>
            <span className="text-wrap font-semibold">{order.orderId}</span>

            <span className="font-medium">Payment Method</span>
            <span className="text-wrap font-semibold">
              {order.paymentDetails.method}
            </span>

            <span className="font-medium">Dimension</span>
            <span className="text-wrap font-semibold">
              {order.packageDetails.volumetricWeight.height} x{" "}
              {order.packageDetails.volumetricWeight.length} x{" "}
              {order.packageDetails.volumetricWeight.width}
            </span>

            <span className="font-medium">Weight</span>
            <span className="text-wrap font-semibold">
              {order.packageDetails.applicableWeight} Kg
            </span>

            <span className="font-medium">Order Value</span>
            <span className="text-start font-semibold">
              ₹{order.paymentDetails.amount}
            </span>
          </div>
        </div>
      </div>

      <UpdateSenderAdd
        isOpen={isModalOpen1}
        onClose={() => setIsModalOpen1(false)}
        onSave={handleUpdateSenderDetails} // Define this function for PUT request
        PickupAddress={order.pickupAddress} // Pass sender details
      />
      <UpdateReceiverAdd
        isOpen={isModalOpen2}
        onClose={() => setIsModalOpen2(false)}
        onSave={handleUpdateRecieverDetails}
        ReceiverAddress={order.receiverAddress} // Ensure this is correct
      />

      <UpdateOrderDetails
        isOpen={isModalOpen3}
        onClose={() => setIsModalOpen3(false)}
        order={order}
        handleUpdateOrderDetails={handleUpdateOrderDetails}
      />
    </div>
  );
};

export default OrderDetails;
